import { render, staticRenderFns } from "./control.vue?vue&type=template&id=5136b4e7&"
import script from "./control.vue?vue&type=script&lang=js&"
export * from "./control.vue?vue&type=script&lang=js&"
import style0 from "./control.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports